export const CUSTOMER_ORDER_NUMBER_MAX_LENGTH = 17;
export const CUSTOMER_NOTES_MAX_LENGTH = 390;
export const CUSTOMER_NOTES_SEED_MAX_LENGTH = 100;
export const SEED_PRODUCT_NOTES_MAX_LENGTH = 390;
export const DEFAULT_SEED_TYPE_VALUE = 'Seed - Processed';
export const SEED_PRODUCT_MIN_PRICE = 0;
export const SEED_PRODUCT_MAX_PRICE = 1000;
export const SEED_PRODUCT_MAX_PACKS = 1000; //TODO: confirm

export const SEED_PRODUCT_MIN_QUANTITY = 0.5;
export const SEED_PRODUCT_MAX_QUANTITY = 1000;
export const TGW_SEGMENTED_BUTTON_UNIT_OPTIONS = [
  {
    label: 'Ha',
    value: 'ha',
  },
  {
    label: 'Ac',
    value: 'ac',
  },
];
export const SEED_NUMBER_UNIT = 'm2';
export const DEFAULT_GERMINATION = 100;
export const QUANTITY_ROUNDINGS = {
  TBA1: (number) => Math.ceil(number),
  TBA5: (number) => Math.ceil(number * 2) / 2,
};

export const TGW_MAX_VALUE_ALLOWED = 99999999;
export const GROUPED_TREATMENT_TYPES = {
  DEFAULT: 'default',
  ADDITIONAL: 'additional',
};
export const TREATMENTS_DROPDOWN_LIMIT = 2;

export const TREATMENTS_REFERENCES = {
  SIGNAL: 'SIGNAL',
};
export const SIGNAL_MAX_DATE = {
  MONTH: '01',
  DAY: '31',
};

export const MILLION_SEED_PACKAGES = [
  '1.5ms',
  '1.8ms',
  '4ms',
  '4msp',
  '2msc',
  '2.1ms',
  '10msp',
  '50kseed',
];
